export enum GameModes {
    CASUAL,
    REALISTIC
}